import {Typography} from "@mui/material";
import React from "react";
import {ProductCardSubtitleProps} from "@/types/product";


export default function ProductCardSubtitle({company, techNumber, sx, ...others}: ProductCardSubtitleProps) {

    return (
        <Typography
            component = "span"
            dir = "auto"
            className = "one-line-ellipsis"
            textAlign = "left"
            display = "block"
            fontFamily="var(--font-sahel-en)"
            minHeight = {20}
            fontSize = {12}
            sx = {{
                opacity: 0.8,
                ...sx
            }}
            {...others}
        >
            {
                (techNumber && techNumber.length > 0) ? (company + ' - ' + techNumber) : (company)}
        </Typography >
    )
}
